import styled from 'styled-components';

const Section = styled.div`
  display: grid;
  grid-gap: ${({ theme }) => theme.space[3]};
`;

export default { Section };
